export const CUSTOMER_REPRESENTATIVE = {
  MYSELF: 'myself',
  SOMEONE_ELSE: 'someoneElse',
};

export const AUTOENROLL = '/autoEnrol';
